/**
 * 抽取范围
 */
export const ExtractionRangeEnum = {
  ALL: 'ALL',
  FIRST: 'FIRST',
  LAST: 'LAST',
  TARGET: 'TARGET',
} as const;

/** 抽取范围 */
const ExtractionRangeMap: Record<keyof typeof ExtractionRangeEnum, string> = {
  [ExtractionRangeEnum.ALL]: '全文',
  [ExtractionRangeEnum.FIRST]: '首页',
  [ExtractionRangeEnum.LAST]: '末页',
  [ExtractionRangeEnum.TARGET]: '指定页',
} as const;

/** 抽取范围 */
export const extractionRangeOptions = Object.entries(ExtractionRangeEnum).map(
  ([key, value]) => ({
    label: ExtractionRangeMap[key as keyof typeof ExtractionRangeMap],
    value: value,
  }),
);

// 格式化类型
export const FORMAT_MAP = {
  CN: '中文',
  NUM: '数字',
  UP: '大写字母',
  LOW: '小写字母',
} as const;

const FORMAT_ENUM = {
  CN: 'CN',
  NUM: 'NUM',
  UP: 'UP',
  LOW: 'LOW',
} as const;

export type FormatEnum = (typeof FORMAT_ENUM)[keyof typeof FORMAT_ENUM];

export const FORMAT_OPTIONS = Object.entries(FORMAT_ENUM).map(
  ([key, value]) => ({
    label: FORMAT_MAP[key as keyof typeof FORMAT_MAP],
    value: value,
  }),
);

// 前缀后缀类型
export const PRE_SUFFIX = {
  TEXT: 'TEXT',
  FORMAT: 'FORMAT',
} as const;

export type PreSuffix = (typeof PRE_SUFFIX)[keyof typeof PRE_SUFFIX];

export const PRE_SUFFIX_MAP = {
  TEXT: '关键词',
  FORMAT: '格式',
} as const;

export const PRE_SUFFIX_OPTIONS = Object.entries(PRE_SUFFIX).map(
  ([key, value]) => ({
    label: PRE_SUFFIX_MAP[key as keyof typeof PRE_SUFFIX_MAP],
    value: value,
  }),
);

export const semanticRuleType = {
  CONDITION: 'CONDITION',
  REGEX: 'REGEX',
} as const;

export type SemanticRuleType =
  (typeof semanticRuleType)[keyof typeof semanticRuleType];

export const SemanticRuleOptions = [
  {
    label: '正则',
    value: semanticRuleType.REGEX,
  },
  {
    label: '语义',
    value: semanticRuleType.CONDITION,
  },
];
